module.exports = __webpack_public_path__ + "img/10.ef186385.png";